// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user-menu_trigger__WpdFG {
    display: flex;
    align-items: center;
    width: 100%;
    grid-gap: 15px;
    border-radius: 0;

    padding: 30px calc(var(--menu-item-padding-x) - 2px);
    transition: background-color 0.4s;
}

.user-menu_triggerFocused__9wC6E {
    background: rgba(var(--light-grey-rgb), 0.5);
}

.user-menu_trigger__WpdFG > *:last-child {
    margin-left: auto;
}

.user-menu_initials__-bb-q {
    width: 25px;
    height: 25px;
    border-radius: 5px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: var(--primary-color);
    color: #fff;
    font-size: 14px;
}

.user-menu_username__ZJRZn {
    font-weight: 500;
    font-size: 16px;
}

.user-menu_menuWrap__yhYSX {
    display: inline-flex;
    width: 100%;
}

.user-menu_dropDown__\\+1eVn {
    width: 100%;
    /*margin-left: 10px;*/
    /*margin-right: 10px;*/
}

.user-menu_dropDownMenu__WJbMT {
    margin-left: 10px;
    margin-right: 10px;
    max-width: calc(100% - 20px);
}
`, "",{"version":3,"sources":["webpack://./src/layouts/components/UserMenu/user-menu.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,cAAc;IACd,gBAAgB;;IAEhB,oDAAoD;IACpD,iCAAiC;AACrC;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,gCAAgC;IAChC,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,4BAA4B;AAChC","sourcesContent":[".trigger {\n    display: flex;\n    align-items: center;\n    width: 100%;\n    grid-gap: 15px;\n    border-radius: 0;\n\n    padding: 30px calc(var(--menu-item-padding-x) - 2px);\n    transition: background-color 0.4s;\n}\n\n.triggerFocused {\n    background: rgba(var(--light-grey-rgb), 0.5);\n}\n\n.trigger > *:last-child {\n    margin-left: auto;\n}\n\n.initials {\n    width: 25px;\n    height: 25px;\n    border-radius: 5px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    background: var(--primary-color);\n    color: #fff;\n    font-size: 14px;\n}\n\n.username {\n    font-weight: 500;\n    font-size: 16px;\n}\n\n.menuWrap {\n    display: inline-flex;\n    width: 100%;\n}\n\n.dropDown {\n    width: 100%;\n    /*margin-left: 10px;*/\n    /*margin-right: 10px;*/\n}\n\n.dropDownMenu {\n    margin-left: 10px;\n    margin-right: 10px;\n    max-width: calc(100% - 20px);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"trigger": `user-menu_trigger__WpdFG`,
	"triggerFocused": `user-menu_triggerFocused__9wC6E`,
	"initials": `user-menu_initials__-bb-q`,
	"username": `user-menu_username__ZJRZn`,
	"menuWrap": `user-menu_menuWrap__yhYSX`,
	"dropDown": `user-menu_dropDown__+1eVn`,
	"dropDownMenu": `user-menu_dropDownMenu__WJbMT`
};
export default ___CSS_LOADER_EXPORT___;
